import React, { Component } from 'react';
import LeftMenu from './FixedLeftMenuConnected';
import MainMenu from './MainMenuConnected';
import Notification from './NotificationConnected';

export default class Layout extends Component {
  constructor(props) {
    super(props);
    this.switchMenu = this.switchMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
    this.state = {
      menuOpen: false
    }
  }

  switchMenu() {
    this.setState({ menuOpen: !this.state.menuOpen });
  }

  closeMenu() {
    this.setState({menuOpen: false})
  }

  render() {
    return (
      <div className='MainLayout'>
        <div className="content">
          <MainMenu />
          <Notification />
          <div className="page__body clearfix">
            <LeftMenu />
            <div className="page__content">
              {this.props.children}
            </div>
          </div>
        </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/Layouts/MainLayout/MainLayout.js